import React, {useState, useEffect} from "react";
import moment from "moment";

import api from "../../service/api";

import { Title, Close, Row, Legend, Info, FieldTitle, ItemName, DetailsOrDownload, NotExist, PlanDetailsContainer, FirstCol, SecondCol, ThirdCol, ItemDetailOrDownloadContainer } from "./styles";

import CreditCard from "../CreditCard";

//Utils
import { translateFrequencyOrInterval } from "../../utils/translate/frequencyOrInterval";


//Assets
import close from "../../assets/icons/close.svg";

//Interfaces
import { ModalClientsDetailPropsInterface, SubscriptionInterface } from "./interfaces";
import { subscription } from "../../data/subscriptions";
import { First } from "react-bootstrap/esm/PageItem";
import { translatePaymentType } from "../../utils/translate/paymentType";

const ModalClientsDetail = (props: ModalClientsDetailPropsInterface) => {
    const [isPlanDetailsShow, setIsPlanDetailsShow] = useState(false);
    const [isCardDetailsShow, setIsCardDetailsShow] = useState(false);
    const [cardData, setCardData] = useState([]);
    const [subscriptionDetail, setSubscriptionDetail] = useState<Array<SubscriptionInterface>>([]);

    useEffect(() => {
        const getCardDataAtApi = async () => {
            const {data} = await api.get("/card/list", {
                params: {
                    cardBuyerId: props.data.bu_id
                }
            });

            setCardData(data.CardBuyer);
        }

        const getBuyerDetailAtApi = async () => {
            const { data } = await api.get("/buyer/list", {
                params: {
                    id: props.data.bu_id
                }
            });
            
            setSubscriptionDetail(data.buyers[0].subscription[0] === null ? [] : data.buyers[0].subscription);
        }

        if(props.data.bu_id !== undefined){
            getCardDataAtApi();
            getBuyerDetailAtApi();
        }
    }, [props.data.bu_id])

    const getInfoForRender = () => {
        if(props.type === "buyers"){
            return {
                businessName: props.data.br_businessName,
                status: props.data.br_status,
                created_at: moment(props.data.br_datahora_cad).format("DD/MM/YYYY"),
                name: `${props.data.bu_firstName} ${props.data.bu_lastName}`,
                taxpayerId: props.data.bu_taxpayerId,
                phoneNumber: props.data.bu_phoneNumber,
                email: props.data.bu_email,
                postalCode: props.data.bu_addressPostalCode,
                city: props.data.bu_addressCity,
                uf: props.data.bu_addressState,
                addressLine1: props.data.bu_addressLine1,
                addressLine2: props.data.bu_addressLine2,
                addressLine3: props.data.bu_addressLine3
            }
        }
        
        if(props.type === "sellers"){
            return {
                businessName: props.data.businessName,
                businessCategory: props.data.businessCategory,
                status: props.data.status,
                created_at: moment(props.data.created_at).format("DD/MM/YYYY"),
                taxpayerId: props.data.taxpayerIdBranch,
                phoneNumber: props.data.businessPhone,
                email: props.data.businessEmail,
                city: props.data.city,
                postalCode: props.data.codePostal,
                uf: props.data.state,
                complement: props.data.complement,
                addressNumber: props.data.number,
                address: props.data.address
            }
        }
        
        if(props.type === "plan"){
            return {
                name: props.data.name,
                status: `${props.data.isActive ? "Ativo" : "Inativo"}`,
                created_at: moment(props.data.datahora_cad).format("DD/MM/YYYY"),
                description: `${props.data.description}`,
                frequency: `${translateFrequencyOrInterval(props.data.frequency)}`,
                gracePeriod: props.data.gracePeriod,
                duration: props.data.duration,
                paymentMethod: `${translatePaymentType(props.data.paymentMethods)}`,
                tolerance: props.data.tolerancePeriod,
                interval: props.data.interval,
                amount: props.data.amount,
                updated: moment.utc(props.data.updated_at).format("DD/MM/YYYY HH:mm")
            }
        }
    }

    const cardGenerate = () => {
        return cardData.map((card: any, index: number) => {
            return(
                <>
                    <ItemDetailOrDownloadContainer>
                        <ItemName>Cartão {index + 1}</ItemName>
                        <DetailsOrDownload onClick={() => setIsCardDetailsShow(!isCardDetailsShow)}>Ver detalhes</DetailsOrDownload>
                    </ItemDetailOrDownloadContainer>
                    <div className={`${isCardDetailsShow ? "d-block": "d-none"}`}>
                        <CreditCard
                            firstNumbers={card.first4Digits}
                            lastNumbers={card.last4Digits}
                            name={card.holderName}
                            cvv=""
                            valid={`${card.expirationMonth}/${card.expirationYear}`}
                        />
                    </div>
                </>
            )
        });
    }

    const subscriptionGenerator = () => {
        return subscriptionDetail.map(subscription => {
            return(
                <div>
                    <ItemDetailOrDownloadContainer>
                        <ItemName>{subscription.name}</ItemName>
                        <DetailsOrDownload onClick={() => setIsPlanDetailsShow(!isPlanDetailsShow)}>Ver detalhes</DetailsOrDownload>
                    </ItemDetailOrDownloadContainer>
                    <PlanDetailsContainer isVisible={isPlanDetailsShow}>
                        <Row>
                            <FirstCol>
                                <Legend>Nome</Legend>
                                <Info>{subscription.name}</Info>
                            </FirstCol>
                            <div>
                                <Legend>Descrição</Legend>
                                <Info>{subscription.description}</Info>
                            </div>
                            <div style={{width: 46}}></div>
                        </Row>
                        <Row>
                            <FirstCol>
                                <Legend>Data de criação</Legend>
                                <Info>{moment(subscription.created_at).format("DD/MM/YYYY hh:mm")}</Info>
                            </FirstCol>
                            <SecondCol>
                                <Legend>Frequência</Legend>
                                <Info>Diariamente</Info>
                            </SecondCol>
                            <ThirdCol>
                                <Legend>Intervalo</Legend>
                                <Info>2</Info>
                            </ThirdCol>
                        </Row>
                        <Row>
                            <FirstCol>
                                <Legend>Período de Carência</Legend>
                                <Info>0</Info>
                            </FirstCol>
                            <SecondCol>
                                <Legend>Tolerância na Falha</Legend>
                                <Info>{subscription.tolerancePeriod}</Info>
                            </SecondCol>
                            <ThirdCol>
                                <Legend>Duração do Plano</Legend>
                                <Info>12</Info>
                            </ThirdCol>
                        </Row>
                        <Row>
                            <FirstCol>
                                <Legend>Valor do Plano</Legend>
                                <Info>R$ {parseInt(subscription.amount).toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2})}</Info>
                            </FirstCol>
                            <SecondCol>
                                <Legend>Valor do Setup</Legend>
                                <Info>R$ 50,00</Info>
                            </SecondCol>
                            <ThirdCol/>
                        </Row>
                        <Row>
                            <div>
                                <Legend>Métodos de Pagamento</Legend>
                                <Info>Crédito</Info>
                            </div>
                        </Row>
                    </PlanDetailsContainer>
                </div>
            )
        })
    }

    let data: any = getInfoForRender();

    return (        
        <div className="modal fade" id="details-plans"  aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-actions">
                <div className="modal-content">
                    <div className="d-flex justify-content-between" style={{paddingTop: 40, paddingBottom: 20}}>
                        <div>
                            <Title>{props.title}</Title>
                            {props.type === "plan" ? 
                                <Info>{`Última atualização ${data.updated}`}</Info>
                            : null}
                        </div>
                        <Close data-dismiss="modal" aria-label="Close">
                            <img src={close} alt="fechar"/>
                        </Close>
                    </div>
                    {props.type === "plan" ? 
                    <div>
                        <FieldTitle>Dados Principais</FieldTitle>
                        <Row>
                            <FirstCol style={{width: 200}}>
                                <Legend>Nome</Legend>
                                <Info>{data.name}</Info>
                            </FirstCol>
                            <SecondCol>
                                <Legend>Descrição</Legend>
                                <Info>{data.description}</Info>
                            </SecondCol>
                            <ThirdCol></ThirdCol>
                        </Row>
                        <Row>
                            <FirstCol style={{width: 200}}>
                                <Legend>Data de criação</Legend>
                                <Info>{data.created_at}</Info>
                            </FirstCol>
                            <SecondCol>
                                <Legend>Frequência</Legend>
                                <Info>{data.frequency}</Info>
                            </SecondCol>
                            <ThirdCol>
                                <Legend>Intervalo</Legend>
                                <Info>{data.interval}</Info>
                            </ThirdCol>
                        </Row>
                        <Row>
                            <FirstCol style={{width: 200}}>
                                <Legend>Período de Carência</Legend>
                                <Info>{data.gracePeriod}</Info>
                            </FirstCol>
                            <SecondCol>
                                <Legend>Tolerância na Falha</Legend>
                                <Info>{data.tolerance}</Info>
                            </SecondCol>
                            <ThirdCol>
                                <Legend>Duração do Plano</Legend>
                                <Info>{data.duration}</Info>
                            </ThirdCol>
                        </Row>
                        <Row>
                            <FirstCol style={{width: 200}}>
                                <Legend>Valor do Plano</Legend>
                                <Info>R$ {(parseInt(data.amount) / 100).toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2})}</Info>
                            </FirstCol>
                            
                            <ThirdCol/>
                        </Row>
                        <Row>
                            <div>
                                <Legend>Métodos de Pagamento</Legend>
                                <Info>{data.paymentMethod}</Info>
                            </div>
                        </Row>
                    </div>
                    : 
                    <div className="modal-body">
                        { props.type === "sellers" ?
                            <>
                                <Row>
                                    <FirstCol style={{width: 350}}>
                                        <Legend>Vendedor</Legend>
                                        <Info>{data.businessName}</Info>
                                    </FirstCol>
                                    <SecondCol>
                                        <Legend>Status</Legend>
                                        <Info>{data.status}</Info>
                                    </SecondCol>
                                    <ThirdCol>
                                        <Legend>Data de criação</Legend>
                                        <Info>{data.created_at}</Info>
                                    </ThirdCol>
                                </Row>
                                <Row>
                                    <FirstCol style={{width: 350}}>
                                        <Legend>Categoria do negócio</Legend>
                                        <Info>{data.businessCategory}</Info>
                                    </FirstCol>
                                </Row>
                            </>
                            : 
                            <Row>
                                <div>
                                    <Legend>Vendedor</Legend>
                                    <Info>{data.businessName}</Info>
                                </div>
                                <div>
                                    <Legend>Status</Legend>
                                    <Info>{data.status}</Info>
                                </div>
                                <div>
                                    <Legend>Data de criação</Legend>
                                    <Info>{data.created_at}</Info>
                                </div>
                            </Row>}

                        <hr style={{marginTop: 0}}/>

                        <FieldTitle>Dados Principais</FieldTitle>
                        {props.type === "sellers" ? 
                            <>
                                <Row>
                                    <FirstCol style={{width: 350}}>
                                        <Legend>Nome</Legend>
                                        <Info>{data.businessName}</Info>
                                    </FirstCol>
                                    <SecondCol>
                                        <Legend>CPF/CNPJ</Legend>
                                        <Info>{data.taxpayerId}</Info>
                                    </SecondCol>
                                    <ThirdCol>
                                        <Legend>Data de nascimento</Legend>
                                        <Info>{}</Info>
                                    </ThirdCol>
                                </Row>
                                <Row>
                                    <FirstCol style={{width: 350}}>
                                        <Legend>Email</Legend>
                                        <Info>{data.email}</Info>
                                    </FirstCol>
                                    <SecondCol>
                                        <Legend>Telefone</Legend>
                                        <Info>{data.phoneNumber}</Info>
                                    </SecondCol>
                                    <ThirdCol></ThirdCol>
                                </Row>
                            </>
                        : 
                            <>
                                <Row>
                                    <div>
                                        <Legend>Nome</Legend>
                                        <Info>{data.name}</Info>
                                    </div>
                                    <div>
                                        <Legend>CPF</Legend>
                                        <Info>{data.taxpayerId}</Info>
                                    </div>
                                    <div>
                                        <Legend>Email</Legend>
                                        <Info>{data.email}</Info>
                                    </div>
                                    <div>
                                        <Legend>Telefone</Legend>
                                        <Info>{data.phoneNumber}</Info>
                                    </div>
                                </Row>
                            </>
                    }
                        

                        <hr style={{marginTop: 0}}/>

                        <FieldTitle>Endereço</FieldTitle>

                        {props.type == "sellers" ?
                            <>
                                <Row>
                                <FirstCol style={{width: 150}}>
                                    <Legend>CEP</Legend>
                                    <Info>{data.postalCode}</Info>
                                </FirstCol>
                                <SecondCol>
                                    <Legend>Cidade</Legend>
                                    <Info>{data.city}</Info>
                                </SecondCol>
                                <div style={{width: 80}}>
                                    <Legend>UF</Legend>
                                    <Info>{data.uf}</Info>
                                </div>
                                <div style={{width: 200}}>
                                    <Legend>Endereço</Legend>
                                        <Info>{data.address}</Info>
                                </div>
                                </Row>
                                <Row>
                                    <FirstCol style={{width: 190}}>
                                        <Legend>Número</Legend>
                                        <Info>{data.addressNumber}</Info>
                                    </FirstCol>
                                    <SecondCol style={{width: 250}}>
                                        <Legend>Complemento</Legend>
                                        <Info>{data.complement}</Info>
                                    </SecondCol>
                                    <ThirdCol></ThirdCol>
                                    <ThirdCol></ThirdCol>
                                </Row>
                            </>
                            :
                            <>
                                <Row>
                                    <div>
                                        <Legend>CEP</Legend>
                                        <Info>{data.postalCode}</Info>
                                    </div>
                                    <div>
                                        <Legend>Cidade</Legend>
                                        <Info>{data.city}</Info>
                                    </div>
                                    <div>
                                        <Legend>UF</Legend>
                                        <Info>{data.uf}</Info>
                                    </div>
                                    <div>
                                        <Legend>Endereço</Legend>
                                        <Info>{data.addressLine1}</Info>
                                    </div>
                                </Row>
                                <Row>
                                    <div style={{width: 78}}>
                                        <Legend>Número</Legend>
                                        <Info>{data.addressLine2}</Info>
                                    </div>
                                    <div>
                                        <Legend>Complemento</Legend>
                                        <Info>{data.addressLine3}</Info>
                                    </div>
                                    <div></div>
                                    <div></div>
                                </Row>
                            </>
                        }

                        <hr style={{marginTop: 0}}/>

                        <FieldTitle>{props.type === "sellers" ? "Planos 100pay": "Assinaturas ativas"}</FieldTitle>

                        { subscriptionGenerator() }

                        <hr style={{marginTop: 0}}/>
                        
                        <FieldTitle>{props.type === "sellers" ? "Documentos" : "Cartões Tokenizados"}</FieldTitle>
                        
                        <div>
                            {props.type === "sellers" ? 
                                <>
                                    <ItemDetailOrDownloadContainer>
                                        <ItemName>Identificação</ItemName>
                                        <DetailsOrDownload>Baixar arquivo</DetailsOrDownload>
                                    </ItemDetailOrDownloadContainer>
                                    <ItemDetailOrDownloadContainer>
                                        <ItemName>Residência</ItemName>
                                        <DetailsOrDownload>Baixar arquivo</DetailsOrDownload>
                                    </ItemDetailOrDownloadContainer>
                                    <ItemDetailOrDownloadContainer>
                                        <ItemName>Atividade</ItemName>
                                        <NotExist>Não existe</NotExist>
                                    </ItemDetailOrDownloadContainer>
                                </>
                            : 
                                cardGenerate()
                            }
                        </div>
                    </div>}
                </div>
            </div>
        </div>
    );
}

export default ModalClientsDetail;